import { AfterViewInit, Component, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import { InsurerType, SharedConfig, SharedDialogService, SharedEncryptionService } from '@takectrl-multiapp/svcs-share-config';
import { UIAppInitializationService } from '../../services/ui-app-initialization.service';
import { BUSNUserService } from '@takectrl-multiapp/svcs-core-business';
import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import '@lottiefiles/lottie-player';
declare const dataLayer: any[];
import { ApiAuthService } from '@takectrl-multiapp/svcs-ctrl-api';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { APIMetaService } from '@takectrl-multiapp/svcs-ctrl-api';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'login-with-otp',
  standalone: false,
  templateUrl: './login-with-otp.component.html',
  styleUrls: ['./login-with-otp.component.scss'],
})
export class LoginWithOtpComponent implements AfterViewInit, OnDestroy {
  private recaptchaContainerId = 'recaptcha-container-' + Math.random().toString(36).substring(2);
  public loginForm: FormGroup;
  public passwordType = 'password';
  public passwordIcon = 'view';
  public passwordError = false;
  public emailError = false;
  msisdnError = false;
  public disableButtonCell = true;
  // private password: string = 'Testing1234!';
  // public userEmail: string = 'aylin.bothafifiteenaugustrefactor@takectrl.co.za';
  showSmallPopup = false;
  smallPopupHeader: string;
  smallPopupMessage: string;
  public disableButtonPassword = false;
  public disableButtonEmail = false;
  public biometricsLoginSetup: string;
  loaderElement: HTMLIonLoadingElement;
  recaptchaVerifier: any;
  confirmationResult: firebase.auth.ConfirmationResult;

  phoneNumber = SharedConfig.routeParamUserMsisdn;

  showOTPScreen = false;
  verificationCodeInputOne: string;
  verificationCodeInputTwo: string;
  verificationCodeInputThree: string;
  verificationCodeInputFour: string;
  verificationCodeInputFive: string;
  verificationCodeInputSix: string;

  public hasFocus: string;
  public otpError = false;
  public displayNumber: string;
  public didResend = false;
  private intervalLoader: any;
  private intervalResent: any;
  completeVerificationCode: string;
  public showLoader = false;
  public maxLength = 6;
  @Output() routeUserToCorrectHomePage: EventEmitter<unknown> = new EventEmitter();
  @Output() navToResetPasswordPage: EventEmitter<unknown> = new EventEmitter();

  @ViewChild('otpInputOne') otpInputOne: { setFocus: () => void };
  @ViewChild('otpInputTwo') otpInputTwo: { setFocus: () => void };
  @ViewChild('otpInputThree') otpInputThree: { setFocus: () => void };
  @ViewChild('otpInputFour') otpInputFour: { setFocus: () => void };
  @ViewChild('otpInputFive') otpInputFive: { setFocus: () => void };
  @ViewChild('otpInputSix') otpInputSix: { setFocus: () => void };
  retryCount = 0;

  constructor(
    public formBuilder: FormBuilder,
    public apiAuthService: ApiAuthService,
    public userService: BUSNUserService,
    public sharedConfig: SharedConfig,
    public sharedEncryptionService: SharedEncryptionService,
    public alertController: AlertController,
    private readonly sharedDialogService: SharedDialogService,
    public angularFireAuth: AngularFireAuth,
    public uiAppInitializationService: UIAppInitializationService,
    public busnThirdPartyService: BUSNThirdPartyService,
    private apiMetaService: APIMetaService
  ) {}

  ngOnDestroy() {
    // Cleanup reCAPTCHA
    if (this.recaptchaVerifier) {
      this.recaptchaVerifier.clear();
    }
    const container = document.getElementById(this.recaptchaContainerId);
    if (container) {
      container.remove();
    }
  }

  async ngAfterViewInit(): Promise<void> {
    if (this.phoneNumber) {
      // this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('reCap', {size: 'invisible'});
      try {
        // Format display number
        this.formatDisplayNumber();
        // Wait for DOM to be ready
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Initialize reCAPTCHA
        await this.initializeRecaptcha();

        // Set focus and send OTP
        this.otpInputOne?.setFocus();
        this.retryCount = 0;
        await this.sendOTP();
      } catch (error) {
        console.error('Error in initialization:', error);
        this.handleInitializationError(error);
        this.sharedConfig.setShowCustomLoader(false)
      }
    }
  }

  private handleInitializationError(error: any) {
    this.sharedDialogService.showPopupDialog({
      header: 'Initialization Error',
      subHeader: 'Failed to initialize verification. Please try again.',
      buttonOneText: 'Retry',
      buttonOneCallback: async () => {
        this.sharedDialogService.hidePopupDialog();
        await this.initializeRecaptcha();
        await this.sendOTP();
      },
    });
  }
  private formatDisplayNumber() {
    const routeNumber = this.phoneNumber;
    const firstPartOfNumber = routeNumber.substring(3, 5);
    const middlePartOfNumber = routeNumber.substring(5, 8);
    const lastPartOfNumber = routeNumber.substring(8, 12);
    this.displayNumber = `0${firstPartOfNumber} ${middlePartOfNumber} ${lastPartOfNumber}`;
  }

  private async initializeRecaptcha() {
    this.sharedConfig.setShowCustomLoader(true)
    try {
      const app = initializeApp(SharedConfig.appCredentials.firebase_credentials);
      const auth = getAuth(app);
      // Cleanup any existing instances
      if (this.recaptchaVerifier) {
        this.recaptchaVerifier.clear();
        this.recaptchaVerifier = null;
      }

      // Remove existing container if present
      const existingContainer = document.getElementById(this.recaptchaContainerId);
      if (existingContainer) {
        existingContainer.remove();
      }

      // Create new container
      const container = document.createElement('div');
      container.id = this.recaptchaContainerId;
      document.body.appendChild(container);

      console.log('Creating new reCAPTCHA verifier...');
      this.recaptchaVerifier = new RecaptchaVerifier(auth, this.recaptchaContainerId, {
        'size': 'invisible',
        'callback': (response) => {
          console.log('reCAPTCHA callback response:', response);
        },
        'expired-callback': () => {
          console.log('reCAPTCHA expired');
          this.handleRecaptchaExpired();
        },
      });

      console.log('Rendering reCAPTCHA...');
      await this.recaptchaVerifier.render();
      console.log('reCAPTCHA setup complete');

      return true;
    } catch (error) {
      console.error('Detailed reCAPTCHA initialization error:', error);
      this.sharedConfig.setShowCustomLoader(false)
      throw error;
    }
  }

  async sendOTP() {
    this.sharedConfig.setShowCustomLoader(true);

    try {
      if (!this.isValidPhoneNumber(this.phoneNumber)) {
        throw new Error('Invalid phone number format');
      }

      // Always reinitialize reCAPTCHA before sending OTP
      await this.initializeRecaptcha();

      console.log('Sending OTP to:', this.phoneNumber);

      this.confirmationResult = await this.angularFireAuth.signInWithPhoneNumber(this.phoneNumber, this.recaptchaVerifier);

      console.log('OTP sent successfully');
      this.retryCount = 0;
    } catch (error) {
      console.error('Error sending OTP:', error);

      if (error.code === 'auth/invalid-app-credential') {
        // Show user-friendly error
        this.sharedDialogService.showPopupDialog({
          header: 'Verification Error',
          subHeader: 'Please try again',
          buttonOneText: 'Retry',
          buttonOneCallback: () => {
            this.sharedDialogService.hidePopupDialog();
            this.sendOTP();
          },
        });
      } else {
        this.handleOTPError(error);
      }
    } finally {
      this.sharedConfig.setShowCustomLoader(false);
    }
  }

  private handleRecaptchaExpired() {
    // Clear the existing instance
    if (this.recaptchaVerifier) {
      this.recaptchaVerifier.clear();
      this.recaptchaVerifier = null;
    }

    this.sharedDialogService.showPopupDialog({
      header: 'Verification Expired',
      subHeader: 'Please try again',
      buttonOneText: 'Retry',
      buttonOneCallback: () => {
        this.sharedDialogService.hidePopupDialog();
        this.sendOTP();
      },
    });
  }

  async resendOTP() {
    let loaderCounter = 2;
    this.showLoader = true;
    await this.sendOTP();
    this.intervalLoader = setInterval(() => {
      loaderCounter = loaderCounter - 1;
      if (loaderCounter === 0) {
        this.showLoader = false;
        this.showResent();
        clearInterval(this.intervalLoader);
      }
    }, 1000);
  }
  private isValidPhoneNumber(phone: string): boolean {
    // Add your phone number validation logic
    return /^\+\d{11,}$/.test(phone);
  }

  private async handleOTPError(error: any) {
    let errorMessage = 'Failed to send verification code';

    if (error.code === 'auth/invalid-phone-number') {
      errorMessage = 'Invalid phone number format';
    } else if (error.code === 'auth/too-many-requests') {
      errorMessage = 'Too many attempts. Please try again later';
    } else if (error.code === 'auth/invalid-app-credential') {
      // Try reinitializing reCAPTCHA
      await this.initializeRecaptcha();
      await this.sendOTP();
      return;
    }

    this.sharedDialogService.showPopupDialog({
      header: 'Verification Failed',
      subHeader: errorMessage,
      buttonOneText: 'Retry',
      buttonOneCallback: () => {
        this.sharedDialogService.hidePopupDialog();
        this.sendOTP();
      },
    });
  }

  showResent() {
    let codeResentCounter = 2;
    this.didResend = true;
    this.intervalResent = setInterval(() => {
      codeResentCounter = codeResentCounter - 1;
      if (codeResentCounter === 0) {
        this.didResend = false;
        clearInterval(this.intervalResent);
      }
    }, 1000);
  }

  setFocusOne(elementHasFocus: string) {
    this.hasFocus = elementHasFocus;
    if (elementHasFocus === 'otpOne') {
      this.verificationCodeInputOne = '';
    }
    if (elementHasFocus === 'otpTwo') {
      this.verificationCodeInputTwo = '';
    }
    if (elementHasFocus === 'otpThree') {
      this.verificationCodeInputThree = '';
    }
    if (elementHasFocus === 'otpFour') {
      this.verificationCodeInputFour = '';
    }
    if (elementHasFocus === 'otpFive') {
      this.verificationCodeInputFive = '';
    }
    if (elementHasFocus === 'otpSix') {
      this.verificationCodeInputSix = '';
    }
  }

  backspaceInputTwo(event: { keyCode: any; charCode: any }) {
    const key = event.keyCode || event.charCode;
    if (key === 8 || key === 46) {
      this.verificationCodeInputOne = '';
      this.verificationCodeInputTwo = '';
      this.otpInputOne.setFocus();
    }
  }

  backspaceInputThree(event: { keyCode: any; charCode: any }) {
    const key = event.keyCode || event.charCode;
    if (key === 8 || key === 46) {
      this.verificationCodeInputTwo = '';
      this.verificationCodeInputThree = '';
      this.otpInputTwo.setFocus();
    }
  }

  backspaceInputFour(event: { keyCode: any; charCode: any }) {
    const key = event.keyCode || event.charCode;
    if (key === 8 || key === 46) {
      this.verificationCodeInputThree = '';
      this.verificationCodeInputFour = '';
      this.otpInputThree.setFocus();
    }
  }

  backspaceInputFive(event: { keyCode: any; charCode: any }) {
    const key = event.keyCode || event.charCode;
    if (key === 8 || key === 46) {
      this.verificationCodeInputFour = '';
      this.verificationCodeInputFive = '';
      this.otpInputFour.setFocus();
    }
  }

  backspaceInputSix(event: { keyCode: any; charCode: any }) {
    const key = event.keyCode || event.charCode;
    if (key === 8 || key === 46) {
      this.verificationCodeInputFive = '';
      this.verificationCodeInputSix = '';
      this.otpInputFive.setFocus();
    }
  }

  onChangeOtpInputOne(e: Event) {
    this.otpError = false;
    const value: string = e.target['value'];
    if (value.length === 6) {
      this.verificationCodeInputOne = value.substring(0, 1);
      this.verificationCodeInputTwo = value.substring(1, 2);
      this.verificationCodeInputThree = value.substring(2, 3);
      this.verificationCodeInputFour = value.substring(3, 4);
      this.verificationCodeInputFive = value.substring(4, 5);
      this.verificationCodeInputSix = value.substring(5, 6);
      this.otpInputSix.setFocus();
    } else {
      this.verificationCodeInputOne = value;
      if (this.verificationCodeInputOne.length > 0) {
        this.otpInputTwo.setFocus();
      } else {
        this.otpInputOne.setFocus();
      }
    }
    this.verifyLoginCode();
  }

  onChangeOtpInputTwo(e: Event) {
    this.otpError = false;
    this.verificationCodeInputTwo = e.target['value'];
    if (this.verificationCodeInputTwo.length > 0) {
      this.otpInputThree.setFocus();
    } else {
      this.otpInputTwo.setFocus();
    }
    this.verifyLoginCode();
  }

  onChangeOtpInputThree(e: Event) {
    this.otpError = false;
    this.verificationCodeInputThree = e.target['value'];
    if (this.verificationCodeInputThree.length > 0) {
      this.otpInputFour.setFocus();
    } else {
      this.otpInputThree.setFocus();
    }
    this.verifyLoginCode();
  }

  onChangeOtpInputFour(e: Event) {
    this.otpError = false;
    this.verificationCodeInputFour = e.target['value'];
    if (this.verificationCodeInputFour.length > 0) {
      this.otpInputFive.setFocus();
    } else {
      this.otpInputFour.setFocus();
    }
    this.verifyLoginCode();
  }

  onChangeOtpInputFive(e: Event) {
    this.otpError = false;
    this.verificationCodeInputFive = e.target['value'];
    if (this.verificationCodeInputFive.length > 0) {
      this.otpInputSix.setFocus();
    } else {
      this.otpInputFive.setFocus();
    }
    this.verifyLoginCode();
  }

  onChangeOtpInputSix(e: Event) {
    this.otpError = false;
    this.verificationCodeInputSix = e.target['value'];
    if (this.verificationCodeInputSix.length > 0) {
      this.verifyLoginCode();
    } else {
      this.otpInputSix.setFocus();
    }
  }

  async verifyLoginCode() {
    this.completeVerificationCode =
      this.verificationCodeInputOne +
      this.verificationCodeInputTwo +
      this.verificationCodeInputThree +
      this.verificationCodeInputFour +
      this.verificationCodeInputFive +
      this.verificationCodeInputSix;
    if (
      this.verificationCodeInputOne &&
      this.verificationCodeInputTwo &&
      this.verificationCodeInputThree &&
      this.verificationCodeInputFour &&
      this.verificationCodeInputFive &&
      this.verificationCodeInputSix
    ) {
      this.sharedConfig.setShowCustomLoader(true);
      try {
        const userCredential = await this.confirmationResult.confirm(this.completeVerificationCode);
        if (userCredential) {
          this.sharedConfig.setFirebaseUser(userCredential.user);
          this.sharedConfig.setFirebaseUserKey(userCredential.user.uid);
          this.sharedConfig.setFirebaseUserEmail(userCredential.user.email);

          SharedConfig.showSetNewPasswordComponent = true;
          SharedConfig.showFooterTabs = false;
          this.sharedConfig.setShowCustomLoader(false);
          this.routeUserToCorrectHomePage.emit();
        }
      } catch (error) {
        this.otpError = true;
        console.log(error, 'Incorrect code entered?');
        this.sharedConfig.setShowCustomLoader(false);
      }
    }
  }

  async setupViaEmail() {
    this.sharedConfig.setShowCustomLoader(true)
    try {
      let response = await this.userService.resetPassword(SharedConfig.routeParamUserEmail);
      if (response.success) {
        this.sharedConfig.setShowCustomLoader(false)
        this.navToResetPasswordPage.emit();
      } else {
        this.sharedConfig.setShowCustomLoader(false)
        this.sharedDialogService.showPopupDialog({
          header: 'Something went wrong!',
          subHeader: response.message,
          buttonOneText: 'Ok',
          buttonOneCallback: this.sharedDialogService.hidePopupDialog,
        });
      }
    } catch (error) {
      this.sharedConfig.setShowCustomLoader(false)
      this.sharedDialogService.showPopupDialog({
        header: 'Something went wrong!',
        subHeader: error.error.message,
        buttonOneText: 'Ok',
        buttonOneCallback: this.sharedDialogService.hidePopupDialog,
      });
    }
  }

  async sendInfoToCallCenter(insurer: InsurerType) {
    SharedConfig.showCustomLoader = true;
    let payload = {
      user_email: this.sharedConfig.routeParamUserEmail,
      insurer: insurer,
    };
    try {
      let result = await firstValueFrom(await this.apiMetaService.sendToCallCenter(payload));
      if (result.success) {
        SharedConfig.showCustomLoader = false;
        this.sharedDialogService.showPopupDialog({
          header: 'Insurer notified',
          subHeader: 'You can expect their call in the next few minutes.',
          buttonOneText: 'OK',
          buttonOneCallback: this.sharedDialogService.hidePopupDialog,
        });
      } else {
        SharedConfig.showCustomLoader = false;
        this.sharedDialogService.showPopupDialog({
          header: 'Something went wrong',
          subHeader: 'Please try again.',
          buttonOneText: 'OK',
          buttonOneCallback: this.sharedDialogService.hidePopupDialog,
        });
      }
    } catch (error) {
      SharedConfig.showCustomLoader = false;
      this.sharedDialogService.showPopupDialog({
        header: 'Something went wrong',
        subHeader: 'Please try again.',
        buttonOneText: 'OK',
        buttonOneCallback: this.sharedDialogService.hidePopupDialog,
      });
    }
  }
}
